<fgb-page-header [backButtonLink]="'/'" [pageTitle]="'terms.page.title'" [showQr]="false"></fgb-page-header>

<div class="container pt-4">
  <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
</div>

<ng-template #defaultTemplate>
  <p class="terms-section-content text-start mb-3">Loading...</p>
</ng-template>
